import { createContext, useContext } from 'react';

import { useFormPanelStack } from '../../hooks/useFormPanelStack';

/** @typedef {ReturnType<typeof useFormPanelStack>} FormPanelContextValue */

const FormPanelContext = createContext(/** @type {FormPanelContextValue | null} */ (null));

/**
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element}
 */
export function FormPanelProvider({ children }) {
  const value = useFormPanelStack();

  return (
    <FormPanelContext.Provider value={value}>
      {children}
    </FormPanelContext.Provider>
  );
}

/**
 * @returns {FormPanelContextValue}
 */
export function useFormPanelContext() {
  const context = useContext(FormPanelContext);
  if (!context) {
    throw new Error('useFormPanelContext must be used within FormPanelProvider');
  }
  return context;
}

/**
 * Optional hook for views that may render outside FormPanelProvider (e.g. Storybook)
 * @returns {FormPanelContextValue | null}
 */
export function useFormPanelContextOptional() {
  return useContext(FormPanelContext);
}
